import Keycloak, {
  KeycloakAccountOptions,
  KeycloakError,
  KeycloakFlow,
  KeycloakInitOptions,
  KeycloakLoginOptions,
  KeycloakLogoutOptions,
  KeycloakProfile,
  KeycloakRegisterOptions,
  KeycloakResourceAccess,
  KeycloakResponseMode,
  KeycloakResponseType,
  KeycloakRoles,
  KeycloakTokenParsed,
} from 'keycloak-js';

export class MockKeycloak implements Keycloak {
  public authenticated?: boolean | undefined = true;
  public subject?: string | undefined;
  public responseMode?: KeycloakResponseMode | undefined;
  public responseType?: KeycloakResponseType | undefined;
  public flow?: KeycloakFlow | undefined;
  public realmAccess?: KeycloakRoles | undefined;
  public resourceAccess?: KeycloakResourceAccess | undefined;
  public token?: string | undefined = 'token';
  public tokenParsed?: KeycloakTokenParsed | undefined;
  public refreshToken?: string | undefined = 'refreshToken';
  public refreshTokenParsed?: KeycloakTokenParsed | undefined;
  public idToken?: string | undefined;
  public idTokenParsed?: KeycloakTokenParsed | undefined;
  public timeSkew?: number | undefined;
  public didInitialize: boolean = true;
  public loginRequired?: boolean | undefined;
  public authServerUrl?: string | undefined;
  public realm?: string | undefined;
  public clientId?: string | undefined;
  public redirectUri?: string | undefined;
  public sessionId?: string | undefined;
  public profile?: KeycloakProfile | undefined;
  // eslint-disable-next-line @typescript-eslint/ban-types
  public userInfo?: {} | undefined;
  public onReady = (_authenticated?: boolean): void => void 0;
  public onAuthSuccess = (): void => void 0;
  public onAuthError = (_errorData: KeycloakError): void => void 0;
  public onAuthRefreshSuccess = (): void => void 0;
  public onAuthRefreshError = (): void => void 0;
  public onAuthLogout = (): void => void 0;
  public onTokenExpired = (): void => void 0;
  public onActionUpdate = (_status: 'success' | 'cancelled' | 'error', _action?: string): void => void 0;
  public init = (_initOptions?: KeycloakInitOptions): Promise<boolean> => Promise.resolve(true);
  public login = (_options?: KeycloakLoginOptions): Promise<void> => Promise.resolve(void 0);
  public logout = (_options?: KeycloakLogoutOptions): Promise<void> => Promise.resolve(void 0);
  public register = (_options?: KeycloakRegisterOptions): Promise<void> => Promise.resolve(void 0);
  public accountManagement = (): Promise<void> => Promise.resolve(void 0);
  public createLoginUrl = (_options?: KeycloakLoginOptions): Promise<string> => Promise.resolve(location.href);
  public createLogoutUrl = (_options?: KeycloakLogoutOptions): string => '';
  public createRegisterUrl = (_options?: KeycloakRegisterOptions): Promise<string> => Promise.resolve('');
  public createAccountUrl = (_options?: KeycloakAccountOptions): string => '';
  public isTokenExpired = (_minValidity?: number): boolean => false;
  public updateToken = (_minValidity?: number): Promise<boolean> => Promise.resolve(true);
  public clearToken = (): void => void 0;
  public hasRealmRole = (_role: string): boolean => true;
  public hasResourceRole = (_role: string, _resource?: string): boolean => true;
  public loadUserProfile = (): Promise<KeycloakProfile> => Promise.resolve({} as Keycloak.KeycloakProfile);
  // eslint-disable-next-line @typescript-eslint/ban-types
  public loadUserInfo = (): Promise<{}> => Promise.resolve({});
}
